<template>
    <div class="clients-list p-3">
        <div class="header-card d-flex justify-content-between align-items-center mb-3 p-3 rounded shadow-sm">
            <div>
                <h2 class="mb-1">Liste des clients</h2>
                <small class="text-muted">Total : {{ clients.length }} clients</small>
            </div>
            <button class="btn btn-purple px-4" @click="$router.push({name: 'clients.create'})">
                <i class="bi bi-person-plus me-1"></i>Ajouter
            </button>
        </div>

        <div class="row mb-3">
            <div class="col-md-6 col-12">
                <input type="text" class="form-control" placeholder="Recherche (nom, prénom, téléphone)" v-model="search"/>
            </div>
        </div>

        <div v-if="clientsToPrint.length > 0">
            <div class="d-none d-md-block table-responsive">
                <table class="table table-hover table-striped align-middle clients-table">
                    <thead class="table-purple text-white">
                        <tr>
                            <th>#</th>
                            <th>Nom</th>
                            <th>Prénoms</th>
                            <th>Téléphone</th>
                            <th>Téléphone 2</th>
                            <th>Adresse</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(c, idx) in clientsToPrint" :key="c.id" class="table-row-hover">
                            <td>{{ idx + 1 }}</td>
                            <td>{{ c.nom || '—' }}</td>
                            <td>{{ c.prenoms || '—' }}</td>
                            <td>{{ c.telephone || '—' }}</td>
                            <td>{{ c.telephone2 || '—' }}</td>
                            <td>{{ c.adresse || '—' }}</td>
                            <td>
                                <button class="btn btn-sm btn-outline-purple me-1" @click="$router.push({name: 'clients.view', params: {id: c.id}})">Voir</button>
                                <button class="btn btn-sm btn-purple" @click="$router.push({name: 'clients.edit', params: {id: c.id}})">Modifier</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="d-block d-md-none">
                <div class="mobile-client-card" v-for="(c, idx) in clientsToPrint" :key="c.id">
                    <div class="d-flex justify-content-between align-items-start">
                        <div>
                            <h6 class="mb-1">{{ c.nom || '—' }} {{ c.prenoms || '' }}</h6>
                            <p class="mb-1"><small class="text-muted">#{{ idx + 1 }} • {{ c.adresse || 'Adresse non renseignée' }}</small></p>
                            <p class="mb-1"><strong>Téléphone:</strong> {{ c.telephone || '—' }} <span v-if="c.telephone2"> / {{ c.telephone2 }}</span></p>
                        </div>
                    </div>
                    <div class="d-flex gap-2 mt-2">
                        <button class="btn btn-sm btn-outline-purple flex-fill" @click="$router.push({name: 'clients.view', params: {id: c.id}})">Voir</button>
                        <button class="btn btn-sm btn-purple flex-fill" @click="$router.push({name: 'clients.edit', params: {id: c.id}})">Modifier</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="alert alert-info rounded">Aucun client trouvé. Essayez un autre filtre.</div>
    </div>
</template>

<script>
export default {
    name: 'ClientsList',
    data() {
        return {
            clients: [],
            search: ""
        }
    },
    computed: {
        clientsToPrint() {
            const s = this.search.trim().toLowerCase();
            if (s.length < 3) {
                return this.clients;
            }

            return this.clients.filter(ele => {
                return (ele.nom?.toLowerCase().includes(s) || false)
                    || (ele.prenoms?.toLowerCase().includes(s) || false)
                    || (ele.telephone?.toLowerCase().includes(s) || false)
                    || (ele.telephone2?.toLowerCase().includes(s) || false);
            });
        }
    },
    methods: {
        getClients() {
            this.$api.get('/clients')
                .then(response => {
                    this.clients = response.data.data;
                })
                .catch(error => {
                    console.error('There was an error fetching the clients!', error);
                });
        }
    },
    created() {
        this.getClients();
    }
}
</script>

<style scoped>
:root {
    --purple-dark: #4c3575;
    --purple: #6a4aa6;
    --purple-light: #c1a7e4;
    --purple-soft: #f2eafc;
}

.clients-list {
    background: linear-gradient(130deg, #f8f2ff 0%, #fff 60%);
}

.header-card {
    background-color: rgba(106, 74, 166, 0.12);
    border: 1px solid rgba(106, 74, 166, 0.3);
}

.btn-purple,
.table-purple,
.btn-outline-purple {
    color: var(--purple);
    background-color: var(--purple);
    border-color: var(--purple);
}

.btn-outline-purple {
    color: var(--purple);
    background-color: transparent;
    border-color: var(--purple);
}

.btn-outline-purple:hover,
.btn-purple:hover,
.clients-list .btn:hover {
    color: var(--purple-light);
    background-color: var(--purple-light) !important;
    border-color: var(--purple-light) !important;
}

.table-purple {
    background-color: var(--purple);
    border-color: var(--purple);
}

.clients-table {
    border: 1px solid rgba(106, 74, 166, 0.3);
    box-shadow: 0 6px 18px rgba(106, 74, 166, 0.12);
}

.table-row-hover:hover {
    background-color: var(--purple-soft);
}

.table th,
.table td {
    vertical-align: middle;
}

.mobile-client-card {
    border: 1px solid rgba(106, 74, 166, 0.3);
    border-radius: 0.6rem;
    background: #fff;
    padding: 0.85rem;
    margin-bottom: 0.9rem;
    box-shadow: 0 4px 12px rgba(106, 74, 166, 0.08);
}

.mobile-client-card h6 {
    margin: 0;
    color: #4c3575;
}

.mobile-client-card p {
    margin: 0.2rem 0;
}

</style>
